import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mfp-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' = 'button';
  @Input() color: 'primary' | 'secondary' | 'light' = 'primary';
  @Input() fill: 'default' | 'clear' | 'outline' = 'default';
  @Input() size: 'medium' | 'small' | 'tiny' | 'large' = 'medium';
  @Input() disabled = false;
  @Input() icon = '';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() label = '';
  @Input() padding: 'default' | 'none' = 'default';

  constructor() {}

  @HostBinding('style.pointer-events') get pEvents(): string {
    if (this.disabled) {
      return 'none';
    }
    return 'auto';
  }

}
